export const PADDING_BOTTOM_VIRTUALIZATION_LIST = 15;
export const CATEGORY_HEIGHT = 37;
export const ITEM_HEIGHT = 20;
export const ITEM_GAP = 20;
export const UNKNOWN_CATEGORY_NAME = 'unknown-category';
export const UNKNOWN_TITLE = 'Unknown Title';
export const UNKNOWN_SUBCATEGORY_NAME = 'unknown-subcategory';
export const UNKNOWN_SUBCATEGORY_TITLE = 'Unknown Subcategory';
export const MAX_WIDTH_OVERFLOW = 290;
